// Map-related constants for Mapbox and Google Maps

export const MAPBOX_STYLE_URL = 'mapbox://styles/mapbox/streets-v11';
export const DEFAULT_CENTER = { lat: 17.385, lng: 78.4867 };
export const DEFAULT_ZOOM = 12;
export const RIDER_MARKER_OFFSET = 0.00018;
export const RIDER_MARKER_ICON = '🛵';
export const PARCEL_MARKER_ICON = '📦';
export const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;

// Google Maps specific
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_DEFAULT_ZOOM = 12;
export const GOOGLE_MAPS_DEFAULT_CENTER = { lat: 17.385, lng: 78.4867 };
